import React from 'react'
import ProjectCreateForm from '../../forms/ProjectCreateForm'

function ProjectAdminCreate() {
  return (
    <ProjectCreateForm />
  )
}

export default ProjectAdminCreate